const getInsuranceMaxWeeklyPrice = (weeklyPrices: { numberOfWeeks: number; weeklySellingPrice: number }[]) =>
  weeklyPrices.reduce((max, current) => (current.numberOfWeeks > max.numberOfWeeks ? current : max));

export default getInsuranceMaxWeeklyPrice;
